import { type AxiosResponse } from 'axios';

import { appIdentityHeaderKey, clearApiClient } from './clearApiClient';
import { planReponseSchema, type PlansAPIResponse } from './schema/plansSchema';
import { logSchemaMismatchError } from './schema/schemaUtils';

const validatePlansResponse = (response: AxiosResponse<PlansAPIResponse>) => {
  const parseResult = planReponseSchema.safeParse(response.data);

  if (!parseResult.success) {
    logSchemaMismatchError(parseResult.error, 'Plans schema mismatch');
    console.error(parseResult.error);

    return response.data; // we ball, anyways
  }

  return parseResult.data;
};

export const fetchPlans = () =>
  clearApiClient.get<PlansAPIResponse>('/web/v1/store/product/plans').then(validatePlansResponse);

export const fetchPublicPlans = (coupon?: string) =>
  clearApiClient
    .get<PlansAPIResponse>(
      `/web/v1/store/products/app-identity?app_identity=${
        clearApiClient.defaults.headers[appIdentityHeaderKey] &&
        typeof clearApiClient.defaults.headers[appIdentityHeaderKey] !== 'object'
          ? clearApiClient.defaults.headers[appIdentityHeaderKey].toString()
          : 'clearvpn2.default'
      }${coupon ? `&coupon=${coupon}` : ''}`,
    )
    .then(validatePlansResponse);
